import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { CraNodeCodingOperation } from "../models/CraWaySnapshot";

export const CraWaySnapshotApi = {
  getPreview: async (snapshotId: string) => {
    return await jwtAuthAxios().get<CraNodeCodingOperation[]>(
      `/cra-way-snapshots/${snapshotId}/preview`
    );
  },

  apply: async (snapshotId: string) => {
    return await jwtAuthAxios().post(`/cra-way-snapshots/${snapshotId}/apply`);
  },
};
